module.exports = __webpack_public_path__ + "static/media/IMG_3279.9a1984cf.JPG";